export const showNotification = (notification) => {
  return { type: 'SHOW_NOTIFICATION', notification }
}
export const removeOldestNotification = () => {
  return { type: 'REMOVE_OLDEST_NOTIFICATION' }
}
